import "./two-col.component.css"

const TwoColComponent = (props) => {
  const { Column } = props

  return (
    <div className="dagger-two-col-container">
      <ul className="dagger-two-col">
        {Column?.map((col, index) => (
          <li className="col" key={index}>
            {col.Heading && <h4>{col.Heading}</h4>}
            {col.Copy && (
              <p dangerouslySetInnerHTML={{ __html: col.Copy }}></p>
            )}
          </li>
        ))}
      </ul>
    </div>
  )
}

export default TwoColComponent
